<template>
  <!-- 编辑子机构弹框 -->
  <el-dialog title="编辑二级团队" width="800px" class="my-dialog-template" :visible.sync="visible" :close-on-click-modal="false">
    <modifyLowerMechanForm ref="modifyLowerMechanForm" @close="visible = false"></modifyLowerMechanForm>
  </el-dialog>
</template>
<script>
import modifyLowerMechanForm from './modifyLowerMechanForm.vue'
export default {
  components: { modifyLowerMechanForm },
  data: () => ({
    loading: false,
    visible: false, // dialog
    id: '', //机构id
  }),
  created() {
  },
  methods: {
    open(id) {
      this.id = id
      this.visible = true
      this.$nextTick(() => {
        this.$refs.modifyLowerMechanForm.open({ id })
      })
    },
  },
}
</script>
<style lang='scss' scoped>
</style>